import { cn } from '../../../lib/utils.ts'
import { type IllustrationProps } from '../illustration.types.ts'

export function ManagerIllustration({
  className,
  'aria-label': ariaLabel = 'Manager',
  'aria-hidden': ariaHidden,
  ...rest
}: IllustrationProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 80 80"
      role="img"
      aria-label={ariaHidden === true ? undefined : ariaLabel}
      aria-hidden={ariaHidden}
      xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block shrink-0', className)}
      {...rest}
    >
      <>
        <defs>
          <linearGradient
            id="manager-paint0_linear_16538_41536"
            x1={45.098}
            x2={46.117}
            y1={74.804}
            y2={48.479}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E7DED2" />
            <stop offset={0.03} stopColor="#E9E1D6" />
            <stop offset={0.16} stopColor="#F3EEE8" />
            <stop offset={0.32} stopColor="#F9F7F5" />
            <stop offset={0.54} stopColor="#FDFDFC" />
            <stop offset={1} stopColor="#fff" />
          </linearGradient>
          <linearGradient
            id="manager-paint1_linear_16538_41536"
            x1={47.943}
            x2={33.324}
            y1={63.016}
            y2={42.537}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CCAE92" />
            <stop offset={0.06} stopColor="#D0B59B" />
            <stop offset={0.35} stopColor="#E4D5C6" />
            <stop offset={0.62} stopColor="#F3EBE5" />
            <stop offset={0.84} stopColor="#FBF9F8" />
            <stop offset={1} stopColor="#fff" />
          </linearGradient>
          <linearGradient
            id="manager-paint2_linear_16538_41536"
            x1={52.211}
            x2={51.666}
            y1={61.66}
            y2={47.705}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#CCAE92" />
            <stop offset={0.31} stopColor="#E0CEBE" />
            <stop offset={0.6} stopColor="#F1E9E1" />
            <stop offset={0.84} stopColor="#FBF9F7" />
            <stop offset={1} stopColor="#fff" />
          </linearGradient>
          <linearGradient
            id="manager-paint3_linear_16538_41536"
            x1={45.178}
            x2={57.495}
            y1={26.36}
            y2={61.428}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.06} stopColor="#EC997C" />
            <stop offset={0.09} stopColor="#EDA387" />
            <stop offset={0.18} stopColor="#F1B79D" />
            <stop offset={0.28} stopColor="#F4C6AF" />
            <stop offset={0.4} stopColor="#F6D1BB" />
            <stop offset={0.57} stopColor="#F7D7C2" />
            <stop offset={1} stopColor="#F8D9C4" />
          </linearGradient>
          <linearGradient
            id="manager-paint4_linear_16538_41536"
            x1={35.131}
            x2={5.956}
            y1={48.513}
            y2={45.356}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8D6544" />
            <stop offset={1} stopColor="#AD8762" />
          </linearGradient>
          <linearGradient
            id="manager-paint5_linear_16538_41536"
            x1={65.958}
            x2={19.215}
            y1={40.835}
            y2={30.871}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8D6544" />
            <stop offset={1} stopColor="#AD8762" />
          </linearGradient>
        </defs>
        <g id="manager-Insurance=-, Generic=Manager">
          <g id="manager-Group 237">
            <path
              id="manager-Vector"
              fill="url(#manager-paint0_linear_16538_41536)"
              d="m51.377 50.512-.02.019c-.513 4.753-2.274 5.704-2.274 5.704-10.264-1.68-15.271-7.778-15.271-7.778.623 1.688 1.944 4.574 4.568 7.924 4.154 5.307 5.194 9.896 4.05 18.004 5.464-.255 10.74-1.21 15.068-2.808.855-10.09-2.646-14.74-6.121-21.061z"
            />
            <path
              id="manager-Vector_2"
              fill="#000"
              d="M42.378 74.638a.2.2 0 0 1-.14-.06.18.18 0 0 1-.044-.155c1.14-8.11.124-12.64-4.02-17.952-2.592-3.319-3.934-6.193-4.604-8.014a.19.19 0 0 1 .083-.23.185.185 0 0 1 .237.046c.011.015 1.275 1.539 3.768 3.247 2.29 1.569 6.112 3.619 11.347 4.492.278-.2 1.685-1.407 2.132-5.557a.2.2 0 0 1 .064-.124.22.22 0 0 1 .166-.053c.056.011.112.038.142.087.403.733.805 1.444 1.2 2.144 3.069 5.421 5.717 10.105 4.957 19.13a.2.2 0 0 1-.12.162c-4.303 1.592-9.545 2.573-15.157 2.833h-.007zm-8.105-25.406c.745 1.78 2.027 4.236 4.194 7.01 4.182 5.356 5.235 9.924 4.13 18.008 5.437-.27 10.515-1.222 14.704-2.757.718-8.834-1.895-13.45-4.92-18.796-.307-.545-.623-1.098-.935-1.666-.587 4.36-2.238 5.304-2.31 5.342a.2.2 0 0 1-.12.019c-8.131-1.336-13.039-5.486-14.742-7.164z"
            />
            <path
              id="manager-Vector_3"
              fill="#000"
              d="m17.447 69.736-5.424-2.371c-.764-.333-.636-1.451.184-1.605l12.146-2.27-6.906 6.25z"
              opacity={0.1}
            />
            <path
              id="manager-Vector_4"
              fill="url(#manager-paint1_linear_16538_41536)"
              d="M33.788 48.457s4.991 6.115 15.225 7.805c-1.171 2.277-.366 5.285-.366 5.285s-6.451-.308-9.722-3.67c-6.14-6.31-5.137-9.42-5.137-9.42"
            />
            <path
              id="manager-Vector_5"
              fill="#000"
              d="M38.358 56.387c-2.624-3.353-3.95-6.24-4.575-7.93a14.1 14.1 0 0 1-6.075 3.858l-4.21 1.337a8.69 8.69 0 0 0-6.071 8.279v7.773c6.575 3.64 16.03 5.113 24.987 4.697 1.143-8.114.106-12.702-4.056-18.018z"
            />
            <path
              id="manager-Vector_6"
              fill="#000"
              d="M39.379 74.638c-8.551 0-16.452-1.704-22.023-4.8a.19.19 0 0 1-.097-.164v-7.786a8.86 8.86 0 0 1 6.193-8.472l4.204-1.34a13.9 13.9 0 0 0 5.983-3.812.18.18 0 0 1 .173-.056.18.18 0 0 1 .139.12c.66 1.794 1.982 4.619 4.538 7.89 4.211 5.392 5.244 9.981 4.087 18.187a.185.185 0 0 1-.176.162 63 63 0 0 1-3.029.07zm-21.745-5.073c6.13 3.37 15.074 5.05 24.6 4.634 1.104-7.992.08-12.487-4.034-17.751-2.455-3.145-3.788-5.884-4.49-7.711a14.26 14.26 0 0 1-5.937 3.696l-4.204 1.34a8.485 8.485 0 0 0-5.931 8.111v7.677z"
            />
            <path
              id="manager-Vector_7"
              fill="#fff"
              d="M38.822 69.621c-3.517 1.438-9.369.303-10.944-.045a.51.51 0 0 1-.4-.502v-5.238c0-.322.295-.566.613-.506 1.733.337 6.773 1.15 10.383.094a.51.51 0 0 1 .659.49v5.231c0 .206-.12.397-.307.472z"
            />
            <path
              id="manager-Vector_8"
              fill="#000"
              d="M34.313 70.496c-2.72 0-5.398-.528-6.457-.761a.7.7 0 0 1-.548-.69v-5.272a.702.702 0 0 1 .832-.694c1.495.294 6.658 1.165 10.261.099a.69.69 0 0 1 .62.113.71.71 0 0 1 .28.565v5.264a.7.7 0 0 1-.422.652c-1.317.543-2.947.728-4.562.728zM28.01 63.44a.33.33 0 0 0-.328.328v5.272c0 .159.104.29.253.32 1.668.37 7.368 1.47 10.8.053a.32.32 0 0 0 .19-.301v-5.265c0-.105-.049-.2-.13-.264a.32.32 0 0 0-.288-.052c-3.589 1.059-8.494.29-10.441-.09q-.031-.008-.063-.008z"
            />
            <path
              id="manager-Vector_9"
              fill="#CCAE92"
              d="M34.216 68.377q-.05.002-.106-.007c-.451-.056-.474-.536-.496-.922-.019-.364-.045-.624-.21-.684-.182-.063-.618.275-.971.554-.527.412-1.133.888-1.697.84q-.289-.023-.38-.212c-.12-.257.12-.591.429-1.007.233-.316.55-.751.512-.967-.004-.026-.015-.06-.064-.096-.226-.156-.392-.045-.81.316-.394.342-.883.765-1.647.806-.094.019-.192-.074-.2-.175a.19.19 0 0 1 .178-.197c.632-.033 1.05-.394 1.418-.713.383-.335.782-.68 1.271-.342q.181.13.222.338c.064.372-.263.814-.58 1.245-.15.205-.372.513-.387.628.015.004.03.004.064.008.433.033.963-.387 1.437-.758.512-.402.956-.751 1.336-.61.41.152.432.628.451 1.015s.05.557.166.572c.207.026.286-.07.474-.35.184-.27.413-.609.925-.735.395-.097.797.16 1.155.383.184.115.462.286.549.256.015-.007.045-.04.072-.141s.127-.16.229-.134a.185.185 0 0 1 .135.227c-.052.208-.154.342-.297.397-.267.104-.553-.078-.887-.29-.294-.185-.629-.393-.862-.334-.372.093-.542.342-.703.584-.166.245-.35.516-.73.516z"
            />
            <path
              id="manager-Vector_10"
              fill="#CCAE92"
              d="M36.853 66.7a.675.675 0 1 1 0-1.352.674.674 0 1 1 0 1.351m0-.97a.294.294 0 1 0 0 .588.294.294 0 0 0 0-.588"
            />
            <path
              id="manager-Vector_11"
              fill="url(#manager-paint2_linear_16538_41536)"
              d="M51.306 50.484c-.518 4.768-2.292 5.721-2.292 5.721 2.954 1.393 3.325 4.329 3.325 4.329 1.252-.48 2.122-1.73 2.671-3.338-1.063-2.215-2.338-4.302-3.613-6.603-.03-.038-.057-.072-.09-.106z"
            />
            <path
              id="manager-Vector_12"
              fill="url(#manager-paint3_linear_16538_41536)"
              d="M63.464 24.057 41.44 22.445 36.83 44.06l-1.438 2.302a14.3 14.3 0 0 1-1.58 2.07s4.996 6.107 15.238 7.795c0 0 1.756-.953 2.27-5.716l.018-.02q-.019-.033-.037-.067a15 15 0 0 0 4.04-.498c9.58-2.585 8.12-25.869 8.12-25.869z"
            />
            <path
              id="manager-Vector_13"
              fill="#000"
              d="M49.05 56.392h-.03c-10.236-1.675-15.366-7.789-15.418-7.853a.19.19 0 0 1 .007-.247 14.5 14.5 0 0 0 1.568-2.038l1.43-2.27 4.621-21.561a.185.185 0 0 1 .2-.146l22.116 1.61c.094.008.17.083.173.177 0 .06.357 5.904-.47 11.989-1.12 8.227-3.753 12.95-7.822 14.041-1.23.33-2.546.498-3.911.506-.53 4.728-2.29 5.732-2.366 5.773a.2.2 0 0 1-.09.023zm-15.053-7.969c.774.862 5.765 6.05 15.008 7.587.279-.199 1.685-1.401 2.133-5.523a.18.18 0 0 1 .01-.172.19.19 0 0 1 .163-.093h.116c1.362 0 2.67-.165 3.892-.495 8.943-2.398 8.127-23.408 8.026-25.483l-21.786-1.585-4.595 21.433a.12.12 0 0 1-.027.06l-1.444 2.3c-.436.69-.936 1.353-1.497 1.971"
            />
            <path
              id="manager-Vector_14"
              fill="url(#manager-paint4_linear_16538_41536)"
              d="M34.638 10.797c-3.73-3.808-16.549-4.052-21.148 5.566-4.904 10.251 3.21 17.047 5.195 21.6 1.757 4.03-.367 9.083-.367 9.083s1.577 2.968 6.491 3.1c.588.014 1.158-.29 1.435-.806.318-.596 1.128-1.62 2.832-1.706 1.828-.09 4.828-1.683 5.416-4.322.457-2.057.146-32.511.146-32.511z"
            />
            <path
              id="manager-Vector_15"
              fill="#000"
              d="M24.894 50.311h-.049c-4.973-.131-6.599-3.077-6.662-3.2a.19.19 0 0 1-.008-.162c.023-.049 2.076-5.032.368-8.942-.454-1.04-1.224-2.188-2.117-3.516-2.917-4.342-6.907-10.285-3.086-18.267 2.76-5.76 8.014-7.426 10.905-7.906 4.226-.702 8.584.236 10.593 2.281a.2.2 0 0 1 .052.132c.011 1.245.308 30.533-.15 32.593-.608 2.728-3.697 4.375-5.6 4.473-1.63.083-2.38 1.043-2.684 1.61-.297.555-.905.908-1.562.908zm-6.34-3.306c.282.447 1.982 2.814 6.299 2.93a1.39 1.39 0 0 0 1.269-.708c.274-.51 1.11-1.711 2.995-1.805 1.787-.09 4.685-1.629 5.251-4.18.44-1.967.162-30.729.143-32.432-1.952-1.93-6.13-2.8-10.21-2.124-2.815.469-7.943 2.09-10.627 7.696-3.727 7.79.196 13.628 3.06 17.895.9 1.343 1.681 2.503 2.15 3.576 1.667 3.816-.045 8.432-.33 9.148z"
            />
            <path
              id="manager-Vector_16"
              fill="#EC997C"
              d="M49.268 31.579s8.97 1.715 13.98-.757c.229-3.65 0-4.83 0-4.83z"
              opacity={0.6}
            />
            <path
              id="manager-Vector_17"
              fill="url(#manager-paint5_linear_16538_41536)"
              stroke="#000"
              strokeLinejoin="round"
              strokeMiterlimit={10}
              strokeWidth={0.3}
              d="M56.187 9.19s10.513 4.392 8.972 17.35c-4.762 6.295-18.825 5.197-18.825 5.197s-.146-3.293-2.343-5.197c-.12 8.995-5.35 13.765-7.24 15.197-.38.29-.903.214-1.224-.14l-5.369-5.928c-1.162-1.284-2.019-2.818-2.268-4.531-.734-5.054-1.093-16.21 8.703-21.288 11.256-5.835 19.594-.66 19.594-.66Z"
            />
            <path
              id="manager-Vector_18"
              fill="#000"
              d="M64.264 59.035c-.425-1.848-1.369-3.534-2.682-4.905-1.456-1.518-2.742-3.33-3.916-5.335a6.6 6.6 0 0 1-2.313 1.154c-1.366.367-2.731.51-4.06.498l.039.067c3.483 6.329 6.989 10.986 6.135 21.083 2.836-1.045 5.266-2.364 7.072-3.937.455-3.256.308-6.096-.275-8.63z"
            />
            <path
              id="manager-Vector_19"
              fill="#000"
              d="M57.471 71.767a.188.188 0 0 1-.188-.203c.751-8.893-1.864-13.518-4.896-18.874-.394-.698-.8-1.412-1.2-2.144l-.038-.067a.2.2 0 0 1 0-.188.19.19 0 0 1 .161-.094h.117c1.358 0 2.664-.165 3.883-.495a6.5 6.5 0 0 0 2.244-1.123.18.18 0 0 1 .15-.034.18.18 0 0 1 .124.09c1.26 2.159 2.529 3.897 3.876 5.308 1.358 1.423 2.3 3.15 2.724 5 .623 2.722.713 5.571.278 8.713a.2.2 0 0 1-.064.116c-1.767 1.547-4.161 2.887-7.114 3.98a.2.2 0 0 1-.064.01zm-5.842-21.19c.368.668.728 1.302 1.08 1.929 3.029 5.349 5.648 9.977 4.969 18.795 2.754-1.047 4.994-2.309 6.668-3.761.42-3.067.326-5.853-.282-8.51a10.36 10.36 0 0 0-2.626-4.824c-1.333-1.396-2.586-3.097-3.824-5.199a6.8 6.8 0 0 1-2.203 1.063 15.3 15.3 0 0 1-3.782.506"
            />
          </g>
        </g>
      </>
    </svg>
  )
}
